export enum ToastErrorDataHooks {
  TOAST_ERRORS = 'toast-errors',
}
